import React from 'react';
import PropTypes from 'prop-types';

import './LoginBlockedMessage.custom.scss';
import './LoginBlockedMessage.theme.scss';

function LoginBlockedMessage({ timer }) {
  if (!timer) {
    return null;
  }

  const minutes = Math.floor(timer / 60) || 1;

  return (
    <div className="login-form-blocked-message">
      <div className="login-form-blocked-message__icon">!</div>
      <div className="login-form-blocked-message__content">{`Your account has been locked for ${minutes} minutes.`}</div>
    </div>
  );
}

LoginBlockedMessage.propTypes = {
  timer: PropTypes.number,
};

export default LoginBlockedMessage;
